<template>
	<div class="task-item-container">
		<input type="checkbox" v-bind:value="isSelected"
		  v-on:change="onSelectTask" v-bind:checked="isSelected"
		/>
		<div class="task-input">
			<input type="text" name="task-item-text"
			  v-bind:disabled="!isSelected" v-bind:value="value"
			  v-on:input="onTextChange" aria-label="Texto"
			/>
			<div class="delete-item">
				<v-icon v-on:click="onCloseTask" class="delete-icon">close</v-icon>
			</div>
		</div>
	</div>
</template>

<script>

const TASK_DELETE_EVENT = 'task-delete';
const TASK_SELECTED_EVENT = 'task-selected';
const TEXT_CHANGE_EVENT = 'input';

function onCloseTask() {
	this.$emit(TASK_DELETE_EVENT, this.value);
}

function onSelectTask() {
	this.$emit(TASK_SELECTED_EVENT, this.isSelected);
}

function onTextChange(e) {
	this.$emit(TEXT_CHANGE_EVENT, e.target.value);
}

export default {
	name: 'task-item',
	props: {
		isSelected: {
			type: Boolean,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
	},
	methods: {
		onCloseTask,
		onSelectTask,
		onTextChange,
	},
};
</script>

<style lang="scss" scoped>
.task-item-container {
	align-items: center;
	display: flex;

	input[type="text"] {
		background-color: white;
		box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);
		height: 40px;
		outline: none;
		padding: 0 30px 0 14px;
		width: 100%;
	}

	input[disabled] {
		background-color: map-get($colors, disabled-habs);
		box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.16);
	}

	.task-input {
		position: relative;
		margin-left: 6px;
		width: 100%;

		.delete-item {
			background-color: map-get($colors, delete-item);
			border-radius: 50%;
			color: white;
			cursor: pointer;
			height: 15px;
			position: absolute;
			right: 9px;
			top: 15px;
			width: 15px;
		}

		.delete-icon {
			font-size: 15px;
			font-weight: bold;
			vertical-align: baseline;
		}
	}
}
</style>




// WEBPACK FOOTER //
// TaskItem.vue?20a3838e